import { Button, Sheet, SheetContent } from '@osteopro/ui';
import { CircleQuestionMark } from 'lucide-react';
import { lazy, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';
import { SectionLoading } from '../common/SectionState.js';

const HelpPanelContent = lazy(async () => import('./HelpPanelContent.js'));

/**
 * Le « ? » de l'en-tête. Le panneau vaut pour l'écran où on l'a ouvert : suivre un lien de
 * l'article mène ailleurs, et le panneau se ferme de lui-même au lieu de parler de l'écran quitté.
 */
export function HelpButton() {
  const { t } = useTranslation();
  const [location] = useLocation();
  const [openedOn, setOpenedOn] = useState<string | null>(null);
  const open = openedOn === location;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        aria-label={t('help:panel.open')}
        title={t('help:panel.open')}
        onClick={() => {
          setOpenedOn(location);
        }}
        data-testid="button-help-panel"
      >
        <CircleQuestionMark className="h-5 w-5" />
      </Button>
      <Sheet
        open={open}
        onOpenChange={(next) => {
          setOpenedOn(next ? location : null);
        }}
      >
        <SheetContent
          className="flex w-full flex-col gap-0 p-0 sm:max-w-md"
          data-testid="sheet-help"
        >
          {open && (
            <Suspense fallback={<SectionLoading />}>
              <HelpPanelContent
                path={location}
                onClose={() => {
                  setOpenedOn(null);
                }}
              />
            </Suspense>
          )}
        </SheetContent>
      </Sheet>
    </>
  );
}
